<template>
  <div>
    <div class="p-3 text-start style-list-header scss-title" :style="style">
      {{ title }}
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "ListHeader",
  props: {
    title: String,
    style: Object,
  },
};
</script>

<style lang="scss" scoped>
.style-list-header {
  background-color: $light-grey;
}
</style>
